var _circle, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_1173_2946)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1173_2946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9366 16.6172C31.8611 16.3951 31.7223 16.1998 31.5372 16.0557C31.3521 15.9115 31.1288 15.8247 30.895 15.806L24.0537 15.2624L21.0933 8.70917C20.999 8.4981 20.8457 8.31883 20.6518 8.19299C20.4578 8.06715 20.2317 8.00013 20.0005 8C19.7693 7.99987 19.5431 8.06665 19.349 8.19228C19.155 8.3179 19.0014 8.497 18.9069 8.70797L15.9465 15.2624L9.10524 15.806C8.87538 15.8242 8.65564 15.9083 8.4723 16.0481C8.28896 16.1879 8.14978 16.3776 8.07142 16.5944C7.99306 16.8113 7.97884 17.0461 8.03045 17.2709C8.08205 17.4956 8.19731 17.7007 8.36243 17.8616L13.4181 22.79L11.6301 30.5325C11.5758 30.7669 11.5932 31.0121 11.68 31.2365C11.7668 31.4608 11.9191 31.6539 12.117 31.7906C12.3149 31.9274 12.5494 32.0015 12.79 32.0033C13.0305 32.0051 13.2661 31.9346 13.4661 31.8009L20.0001 27.4449L26.5341 31.8009C26.7385 31.9366 26.9796 32.0065 27.2249 32.0011C27.4702 31.9957 27.708 31.9154 27.9062 31.7708C28.1045 31.6263 28.2537 31.4245 28.3339 31.1926C28.414 30.9607 28.4212 30.7098 28.3546 30.4737L26.1597 22.7937L31.603 17.8952C31.9594 17.5736 32.0902 17.072 31.9366 16.6172Z",
    fill: "url(#paint1_linear_1173_2946)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1173_2946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.963 14.0267C30.919 13.8971 30.838 13.7832 30.73 13.6991C30.6221 13.6151 30.4918 13.5644 30.3554 13.5535L26.3647 13.2364L24.6378 9.41368C24.5828 9.29056 24.4933 9.18598 24.3802 9.11258C24.2671 9.03917 24.1351 9.00007 24.0003 9C23.8654 8.99993 23.7335 9.03888 23.6203 9.11216C23.5071 9.18544 23.4175 9.28992 23.3624 9.41298L21.6354 13.2364L17.6447 13.5535C17.5106 13.5641 17.3825 13.6132 17.2755 13.6947C17.1686 13.7763 17.0874 13.8869 17.0417 14.0134C16.996 14.1399 16.9877 14.2769 17.0178 14.408C17.0479 14.5391 17.1151 14.6587 17.2114 14.7526L20.1605 17.6275L19.1175 22.144C19.0859 22.2807 19.096 22.4237 19.1467 22.5546C19.1973 22.6855 19.2861 22.7981 19.4016 22.8779C19.5171 22.9576 19.6538 23.0009 19.7941 23.0019C19.9345 23.003 20.0719 22.9619 20.1885 22.8839L24.0001 20.3428L27.8116 22.8839C27.9308 22.963 28.0714 23.0038 28.2145 23.0006C28.3576 22.9975 28.4963 22.9506 28.612 22.8663C28.7276 22.782 28.8147 22.6643 28.8614 22.529C28.9082 22.3937 28.9124 22.2474 28.8735 22.1097L27.5932 17.6296L30.7684 14.7722C30.9763 14.5846 31.0526 14.292 30.963 14.0267Z",
    fill: "url(#paint2_linear_1173_2946)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1173_2946",
    x: 4,
    y: 5,
    width: 35,
    height: 32.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.419608 0 0 0 0 0.458824 0 0 0 0 0.623529 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1173_2946"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.494118 0 0 0 0 0.65098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1173_2946",
    result: "effect2_dropShadow_1173_2946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1173_2946",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1173_2946",
    x: 13,
    y: 6,
    width: 25,
    height: 22.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.419608 0 0 0 0 0.458824 0 0 0 0 0.623529 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1173_2946"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.494118 0 0 0 0 0.65098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1173_2946",
    result: "effect2_dropShadow_1173_2946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1173_2946",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1173_2946",
    x1: 40,
    y1: 20,
    x2: -0.00000136342,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1173_2946",
    x1: 17.5,
    y1: 16,
    x2: 32,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54BAD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C064A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1173_2946",
    x1: 22.5417,
    y1: 13.6667,
    x2: 30,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C064A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumStar);
export default __webpack_public_path__ + "static/media/PremiumStar.16bd9f463db1d6515625acfeb8f8809c.svg";
export { ForwardRef as ReactComponent };